<app-header></app-header>

<div class="wrapper">
    <div class="section_wrapper " [ngStyle]="{marginTop: isLoggedIn?'24px':'96px'}">
        <form class="add_listing_form">
            <h1 class="title font_40_a32">
                Add Listing
            </h1>
            <mat-form-field class="w_100 searchTextField">
                <mat-label class="label">Enter property address to continue</mat-label>
                <input matInput placeholder="" type="text" name="address" #addresstext>
                <app-icon-button matSuffix [margin]="'0 5px 0 0'">
                    <div class="arrow_icon"></div>
                </app-icon-button>

            </mat-form-field>
        </form>
        <div class="add_listig_images">
            <div>
                <img class="map_images " src="../../../assets/images/philipedia.jpg">
                <div class="overlayText">
                    Philadelphia, PA
                </div>
            </div>
            <div>
                <img class="map_images " src="../../../assets/images/orlando.jpg">
                <div class="overlayText">
                    Orlando, FL
                </div>
            </div>
            <div>
                <img class="map_images " src="../../../assets/images/denver.jpg">
                <div class="overlayText">
                    Denver, CO
                </div>
            </div>
        </div>
    </div>


</div>